import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {Routes} from "../../../routes";
import CapacidadInstalada from "../../components/CostosFijos/CapacidadInstalada";
import React from "react";
import InversionSerVivo from "../../components/Inversion/InversionSerVivo";

function InversionSerVivoPage() {
    const navigate = useHistory();
    const ciemId = useSelector(state => state.ciem.ciemId);
    if(!ciemId){
        alert("Para ingresar a esta opcion debe seleccionar una idea de negocio");
        //console.log("no tiene ciem")
        navigate.push(Routes.ListCiemPage.path);
    }
    return (
        <div>
            <InversionSerVivo ciemId={ciemId}/>
        </div>
    );
}

export default InversionSerVivoPage;